// Keep the entire desktop composition within the first viewport below the header.
if (!customElements.get('anso-home-hero')) {
  customElements.define('anso-home-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.fit = () => {
        const top = this.getBoundingClientRect().top + window.scrollY;
        this.style.setProperty('--anso-hero-available-height', `${Math.max(0, window.innerHeight - top)}px`);
      };
      this.fit();
      window.addEventListener('resize', this.fit, { passive: true, signal });
      this.headerObserver = new ResizeObserver(() => {
        // The sticky header shrinks during scrolling; do not resize the hero then.
        if (window.scrollY <= 1) this.fit();
      });
      document.querySelectorAll('.shopify-section-group-header-group').forEach(header => {
        this.headerObserver.observe(header);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.headerObserver?.disconnect();
    }
  });
}
